export default {
  production: {
    clientId: '0oa2ul8rlePlNldiQ5d7',
    issuer: 'https://login.guesty.com/oauth2/ausugy60guDTB3ex05d7',
  },
  staging13: {
    clientId: '0oa3p7juvrddC0bhi5d7',
    issuer: 'https://login-staging13.guesty.com/oauth2/ausug0yozyqtjnB4U5d7',
  },
};
